export const NOT_FOUND_INDEX = -1;
